import * as React from "react";
import TextField from "@material-ui/core/TextField";
import AllWithdrawalRequestsContainer from "app/components/AppComponents/Withdrawals/AllWithdrawalRequestsContainer";
import * as moment from "moment";
import { ChildProps } from "react-apollo";
import { DialogProp } from "app/utils/withDialog";
import { InputLabel, MenuItem, Select } from "@material-ui/core";

type GqlWithholdMutationResult = {
  withhold_withdrawal_request: {
    id: string;
  };
};

type GqlPauseMutationResult = {
  pause_withdrawal_request: {
    id: string;
  };
};

type GqlResumeMutationResult = {
  resume_withdrawal_request: {
    id: string;
  };
};

type Props = ChildProps<
  BOComponentProps & DialogProp,
  GqlWithholdMutationResult & GqlPauseMutationResult & GqlResumeMutationResult
>;

type State = {
  createdAtFrom: string;
  createdAtTo: string;
  status: string;
};

class WithdrawalRequests extends React.Component<Props, State> {
  state = {
    createdAtFrom: null,
    createdAtTo: null,
    status: null,
  };

  componentDidMount() {
    this.props.setHeader({
      title: "Wallet Withdrawal Requests",
      description: "SnapScan Wallet Withdrawal Requests",
    });
  }

  onChangeFromDate(yyyyMmDd) {
    this.setState({
      createdAtFrom: moment(yyyyMmDd, "YYYY-MM-DD").toISOString(),
    });
  }

  onChangeToDate(yyyyMmDd) {
    this.setState({
      createdAtTo: moment(yyyyMmDd, "YYYY-MM-DD").toISOString(),
    });
  }

  onChangeStatus(status) {
    this.setState({
      status: status,
    });
  }

  onAction() {
    this.props.data.refetch();
  }

  render() {
    return (
      <section id="Wallet_Withdrawal_Requests_List" className="padded">
        <h3
          style={{
            borderBottom: "1px solid rgb(204, 204, 204)",
            fontWeight: 400,
            display: "flex",
            alignItems: "center",
            marginTop: 0,
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "flex-start",
            }}
          >
            <TextField
              type="date"
              placeholder="From"
              onChange={(event) => this.onChangeFromDate(event.target.value)}
              style={{
                width: "200px",
                marginRight: "10px",
              }}
            />
            <TextField
              type="date"
              placeholder="To"
              onChange={(event) => this.onChangeToDate(event.target.value)}
              style={{
                width: "200px",
                marginRight: "10px",
              }}
            />
            <InputLabel
              htmlFor="filter-select"
              style={{
                alignSelf: "center",
                flex: "auto",
                marginRight: "10px",
              }}
            >
              Filter
            </InputLabel>
            <Select
              type="string"
              id="filter-select"
              onChange={(event) => this.onChangeStatus(event.target.value)}
              style={{
                width: "200px",
                marginRight: "10px",
              }}
              value={this.state.status}
            >
              <MenuItem value={null}>None</MenuItem>
              <MenuItem value={"pending"}>Pending</MenuItem>
              <MenuItem value={"reserved"}>Reserved</MenuItem>
              <MenuItem value={"withheld"}>Withheld</MenuItem>
              <MenuItem value={"paused"}>Paused</MenuItem>
              <MenuItem value={"error"}>Error</MenuItem>
              <MenuItem value={"released"}>Released</MenuItem>
            </Select>
          </div>
        </h3>

        <AllWithdrawalRequestsContainer
          name={"wallet.withdrawal.requests"}
          createdAtFrom={this.state.createdAtFrom}
          createdAtTo={this.state.createdAtTo}
          status={this.state.status}
        />
      </section>
    );
  }
}

export default WithdrawalRequests;
